import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { FadeIn } from '@/components/motion/FadeIn';
import { MaskReveal } from '@/components/motion/Reveal';

interface Props {
  headline: string;
  primary_cta_label: string;
  primary_cta_href: string;
  variant?: 'gold' | 'dark';
}

export function HomeCtaBand({ headline, primary_cta_label, primary_cta_href, variant = 'gold' }: Props) {
  return (
    <MaskReveal className="section-y-lg" tilt={-2} duration={1.4} sheen>
      <div className="container-default">
        <FadeIn>
          <div className="relative overflow-hidden rounded-2xl border border-gold-500/30 px-8 py-16 text-center md:px-16 md:py-24">
            <div
              aria-hidden
              className={`absolute inset-0 ${
                variant === 'gold' ? 'gradient-cta opacity-10' : 'bg-bg-subtle'
              }`}
            />
            <div className="relative">
              <h2 className="display-serif text-display-l text-fg">{headline}</h2>
              <p className="mx-auto mt-4 max-w-xl text-fg-muted">
                Whether you're launching a new product or modernising an existing one, we'd love to hear from you.
              </p>
              <div className="mt-8">
                <Button asChild size="xl">
                  <Link to={primary_cta_href}>
                    {primary_cta_label}
                    <ArrowRight className="h-4 w-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </MaskReveal>
  );
}
